<template>
  <v-container tag="section">
    <material-wizard
      v-if="renderizacaoLiberada"
      v-model="tab"
      class="mx-auto"
      :title="title"
      :available-steps="availableSteps"
      :tabs="tabs"
      :maxWidth="tipoConciliacao == 'Express' ? '700' : '870'"
      subtitle="Preencha as Informações para gerar sua conciliação."
      :loading="loading"
      btnSaveCustomId="btn-save-conciliacao"
      @click:next="next()"
      @click:prev="back()"
    >
      <conciliacoes-wizard-tabs
        v-if="tipoConciliacao == 'Express'"
        ref="parametrosConciliacaoExpress"
        :conciliacao="conciliacao"
        :tab.sync="tab"
        @partidaTabAvailable="validTabs[1] = $event"
        @referenciaTabAvailable="validTabs[2] = $event"
        @estimativaTempoTabAvailable="validTabs[3] = $event"
        @btnFinishAvailable="validTabs[4] = $event"
      />
      <conciliacao-custom-wizard-tabs
        v-else-if="tipoConciliacao == 'Custom'"
        ref="parametrosConciliacaoCustom"
        :conciliacao="conciliacao"
        :tab.sync="tab"
        @partidaTabAvailable="validTabs[1] = $event"
        @referenciaTabAvailable="validTabs[2] = $event"
        @estimativaTempoTabAvailable="validTabs[3] = $event"
        @btnFinishAvailable="validTabs[4] = $event"
      />
    </material-wizard>
  </v-container>
</template>

<script>
  import ConciliacoesService from '@/services/ConciliacoesService.js';

  export default {
    name: 'ConciliacoesEdit',

    components: {
      MaterialWizard: () => import('@/components/base/MaterialWizard.vue'),
      ConciliacoesWizardTabs: () => import('@/components/conciliacoes/ConciliacoesWizardTabs.vue'),
      ConciliacaoCustomWizardTabs: () => import('@/components/conciliacoes/ConciliacaoCustomWizardTabs.vue')
    },

    data() {
      return {
        tipoConciliacao: '',
        tab: 0,
        tabs: ['Início', 'Partida', 'Referência', 'Estimativa de tempo'],
        availableSteps: [0],
        /* 0 = 'base contábil', 1 = 'banco de preços', 2 = '% -> (COM, CA, SA)', 3 = 'estimativa de tempo', 4 = 'btn finalizar' */
        validTabs: { 0: true, 1: false, 2: false, 3: false, 4: undefined },
        conciliacao: {},
        loading: false,
        tempoEstimado: null
      };
    },

    computed: {
      title() {
        return this.$route.params.id
          ? `Editando Conciliação ${this.tipoConciliacao}`
          : `Adicionar Nova Conciliação ${this.tipoConciliacao}`;
      },
      user() {
        return this.$store.getters.getUser;
      },
      renderizacaoLiberada() {
        if (!this.$route.params.id) return true;

        return this.$route.params.id && JSON.stringify(this.conciliacao) !== '{}' ? true : false;
      },
      stepsProps() {
        return Object.values(this.validTabs).join('|');
      },
      getTipoConciliacaoByRouter() {
        let breadcrumb = this.$route.meta.breadcrumb;
        return breadcrumb ? breadcrumb[3]['name'] : '';
      }
    },

    created() {
      this.tipoConciliacao = this.getTipoConciliacaoByRouter;

      if (this.$route.params.id) this.getConciliacao(this.$route.params.id);
    },

    methods: {
      next() {
        if (this.tab === this.tabs.length - 1) {
          this.salvarConciliacao();
        } else {
          this.tab++;
        }
      },
      back() {
        this.tab--;
      },
      getConciliacao(id) {
        ConciliacoesService.getConciliacao(id)
          .then((response) => {
            this.availableSteps = [0, 1, 2, 3, 4];
            this.validTabs = { 0: true, 1: true, 2: true, 3: true, 4: true };
            this.tipoConciliacao = response.data.conciliacao.tipo_conciliacao == 'Express' ? 'Express' : 'Custom';
            this.conciliacao = response.data.conciliacao;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error(
              'Não foi possivel recuperar todos os dados da conciliação<br>Por favor, preencha novamente os dados necessários.',
              '',
              { position: 'topRight' }
            );

            this.tipoConciliacao = err.data.conciliacao.tipo_conciliacao == 'Express' ? 'Express' : 'Custom';
            this.conciliacao = err.data.conciliacao;
          });
      },
      salvarConciliacao() {
        const id = !this.$route.params.id ? null : this.$route.params.id;
        const data = this.getDadosConciliacao();

        this.loading = true;

        ConciliacoesService.salvarConciliacao(id, data)
          .then(() => {
            this.$router.push({ name: 'Conciliações Histórico' });
            this.$toast.success('Conciliação salva com sucesso.', '', { position: 'topRight' });
          })
          .catch((err) => {
            console.error('Erro: ', err);
            this.$toast.error('Erro ao salvar conciliação.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },
      getDadosConciliacao() {
        const conciliacao = this.$refs[`parametrosConciliacao${this.tipoConciliacao}`];
        return conciliacao.getDadosConciliacao();
      }
    },

    watch: {
      stepsProps() {
        const qtdSteps = this.tabs.length;

        for (let i = 1; i <= qtdSteps; i++) {
          this.validTabs[i] && this.validTabs[i - 1]
            ? this.availableSteps.push(i)
            : (this.availableSteps = this.availableSteps.filter((key) => key != i));
        }

        if (this.validTabs[qtdSteps - 1] && this.validTabs[qtdSteps] == undefined) this.availableSteps.push(qtdSteps);
      }
    }
  };
</script>